import React, { useState, useEffect } from "react";
import "./RatingsTable.css";
import RatingsTable from "./RatingsTable";
import RatingTableSelectors from "./RatingTableSelectors";
import RatingsTableHeader from "./RatingsTableHeader";
import { useTranslation } from "react-i18next";

const RatingsTableView = ({
  holes,
  teeRatings,
  selectedGuide,
  setSelectedGuide,
  clubData,
}) => {
  const [teesData, setTeesData] = useState([]);
  const [ratingsData, setRatingsData] = useState([]);
  const [selectedTeeId, setSelectedTeeId] = useState("");
  const [selectedSex, setSelectedSex] = useState("male");
  const [courseHandicap, setCourseHandicap] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const firstPageTees = holes[0]?.tees ?? [];
    const ratings = teeRatings

    const addedTeeNames = new Set();

    const tees = ratings
      .map((rating) => {
        const tee = firstPageTees.find((t) => t.name === rating.tee);

        if (tee && !addedTeeNames.has(tee.name)) {
          addedTeeNames.add(tee.name);
          return {
            ...tee, // adds all the properties of tee to the object
            name: tee.name,
          };
        }

        return null;
      })
      .filter((tee) => tee !== null)
      .sort((a, b) => a.name.localeCompare(b.name));

    setTeesData(tees);
    setRatingsData(ratings); //gets the ratings from the teeRatings. even those that dont match. maybe change?
    if (ratings.length > 0) {
      setSelectedTeeId(tees[0]?.name); //sets the default selected tee (in the dropdown) to the first tee in the list
    } else {
      setSelectedTeeId(null);
    }
  }, [holes, teeRatings]);

  const rating = ratingsData.find((r) => r.tee === selectedTeeId);
  const tee = teesData.find((t) => t.name === selectedTeeId);

  // sets the course rating and slope rating based on the selected sex
  const courseRating =
    selectedSex === "male"
      ? rating?.course_rating_male
      : rating?.course_rating_female;
  const slopeRating =
    selectedSex === "male"
      ? rating?.slope_rating_male
      : rating?.slope_rating_female;

  const totalPar = holes.reduce((total, page) => {
    const hole = page.tees.find((t) => t.name === selectedTeeId);
    return total + (hole ? hole.par : null);
  }, 0);

  return (
    <div id="glfr-ratings-container">
      <div>
        <RatingTableSelectors
          setCourseHandicap={setCourseHandicap}
          slopeRating={slopeRating}
          courseRating={courseRating}
          totalPar={totalPar}
          selectedGuide={selectedGuide}
          setSelectedGuide={setSelectedGuide}
          guides={clubData.guides}
          selectedTeeId={selectedTeeId}
          setSelectedTeeId={setSelectedTeeId}
          selectedSex={selectedSex}
          setSelectedSex={setSelectedSex}
          teesData={teesData}
        />
        {courseRating && slopeRating && tee ? (
          <div>
            <RatingsTableHeader
              courseRating={courseRating}
              slopeRating={slopeRating}
              totalPar={totalPar}
            />
            <RatingsTable
              courseRating={courseRating}
              slopeRating={slopeRating}
              totalPar={totalPar}
              courseHandicap={courseHandicap}
            />
          </div>
        ) : (
          <div>
            <h3>{t("ratings_no_data")}</h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default RatingsTableView;
